import { render, staticRenderFns } from "./NewAuth.vue?vue&type=template&id=01c00a8f&scoped=true&"
import script from "./NewAuth.vue?vue&type=script&lang=js&"
export * from "./NewAuth.vue?vue&type=script&lang=js&"
import style0 from "./NewAuth.vue?vue&type=style&index=0&id=01c00a8f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c00a8f",
  null
  
)

export default component.exports